export default __webpack_public_path__ + "static/media/backgroundLogoBelobank.eab3c7e3.svg";